/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_A7Inputs */

const en_diff_faq_a7 = /** @type {(inputs: Diff_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Both sides are parsed before comparison, so indentation, whitespace, and the order of object keys are invisible to the diff. Only the parsed values are compared.`)
};

const ko_diff_faq_a7 = /** @type {(inputs: Diff_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아닙니다. 비교 전에 양쪽을 파싱하므로 들여쓰기, 공백, 객체 키 순서는 diff에 보이지 않습니다. 파싱된 값만 비교됩니다.`)
};

const ja_diff_faq_a7 = /** @type {(inputs: Diff_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。比較の前に両側をパースするので、インデント、空白、オブジェクトキーの順序は差分に見えません。パースされた値だけが比較されます。`)
};

/**
* | output |
* | --- |
* | "No. Both sides are parsed before comparison, so indentation, whitespace, and the order of object keys are invisible to the diff. Only the parsed values are c..." |
*
* @param {Diff_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_a7 = /** @type {((inputs?: Diff_Faq_A7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_A7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_a7(inputs)
	if (locale === "ko") return ko_diff_faq_a7(inputs)
	return ja_diff_faq_a7(inputs)
});